<div class="layout-column" [ngClass]="size">
  <img *ngIf="url" [src]="url">

  <div *ngIf="!url"
       class="name-div layout-row layout-align-center-center" [ngStyle]="{'background-color': color || '#d8d8d8' }">
    <span>{{user | userInitials}}</span>
  </div>

</div>

